import { render, staticRenderFns } from "./ResizeFocalPoint.vue?vue&type=template&id=0673c51e&scoped=true&"
import script from "./ResizeFocalPoint.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ResizeFocalPoint.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ResizeFocalPoint.vue?vue&type=style&index=0&id=0673c51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673c51e",
  null
  
)

export default component.exports